import React from "react"
import SLAWrapper from './SLA.style'

// console.log(SLA_CONTENT)

const SLA = ({ children }) => (
  <SLAWrapper>
    <div className="SLA">
      <div className="row expanded small-collapse">
        <div className=" columns small-12 container">
          {children}
        </div>
      </div>
    </div>
  </SLAWrapper >
);

export default SLA;